import React, { useEffect, useRef, useState, useMemo } from "react"
import tw from "twin.macro"
import maplibregl from "maplibre-gl"
import "maplibre-gl/dist/maplibre-gl.css"
import { mapStyleObj, mapStyles } from "./mapStyle"
import { storesToGeoJSON, transformStoreData } from "./geoJSONTools"





const StoreMap = ({
  stores = [],
  selectedStore = null,
  onStoreSelect,
  className = "",
}) => {
  const mapContainer = useRef(null)
  const map = useRef(null)
  const [mapLoaded, setMapLoaded] = useState(false)
  // Función para transformar los datos de las tiendas

  // Transformar todas las tiendas

  // Convertir tiendas a GeoJSON
  // useEffect(() => {

  //   setStoresGeoJSON(theStoresGeoJSON)
  // }, [selectedStore])

  // Inyectar estilos CSS para el mapa oscuro
  useEffect(() => {
    const styleElement = document.createElement("style")
    styleElement.textContent = mapStyles
    document.head.appendChild(styleElement)

    return () => {
      document.head.removeChild(styleElement)
    }
  }, [])

  // Inicializar el mapa
  useEffect(() => {
    if (map.current || !mapContainer.current) return
    const storesGeoJSON = storesToGeoJSON(stores, selectedStore)
    //onsole.log("storesGeoJSON", storesGeoJSON)
    map.current = new maplibregl.Map({
      container: mapContainer.current,
      style: mapStyleObj, // Estilo base gratuito
      center: [-3.7038, 40.4168], // Madrid como centro por defecto
      zoom: 6,
      // scrollZoom: false, // Desactivar zoom con rueda del ratón
      boxZoom: true, // Permitir zoom con selección de área
      doubleClickZoom: true, // Permitir zoom con doble clic
      touchZoomRotate: true, // Permitir zoom táctil en móviles
    })

    // Añadir controles de zoom
    map.current.addControl(
      new maplibregl.NavigationControl({
        showCompass: false,
        showZoom: true,
      }),
      "top-right"
    )

    map.current.on("load", () => {
      setMapLoaded(true)
      //onsole.log("storesGeoJSON", storesGeoJSON)
      // Añadir la fuente de datos cuando el mapa se carga
      map.current.addSource("stores", {
        type: "geojson",
        data: storesGeoJSON,
        cluster: false,
        clusterMaxZoom: 14, // Max zoom to cluster points on
        clusterRadius: 50, // Radius of each
      })
      map.current.addLayer({
        id: "circleOut",
        type: "circle",
        source: "stores",
        paint: {
          "circle-color": "#A99D88", // Color original para tiendas no seleccionadas
          "circle-radius": 19,
        },
      })
      map.current.addLayer({
        id: "circleIn",
        type: "circle",
        source: "stores",
        paint: {
          "circle-color": [
            "case",
            ["get", "isSelected"],
            "#474747", // Negro para tienda seleccionada
            "#FFFFFF", // Blanco para tiendas no seleccionadas
          ],
          "circle-radius": 15,
        },
      })

      map.current.addLayer({
        id: "storesIndex",
        type: "symbol",
        source: "stores",
        layout: {
          "text-field": "{numero}", // Replace with the property that contains the title
          "text-font": ["Open Sans Bold"],
          "text-size": 14,
          "text-anchor": "center",
          "text-offset": [0, 0],
          "text-justify": "center",
          "text-max-width": 16,
        },
        paint: {
          "text-color": [
            "case",
            ["get", "isSelected"],
            "#FFFFFF", // Blanco para tienda seleccionada
            "#474747", // Color original para tiendas no seleccionadas
          ],
          "text-halo-color": [
            "case",
            ["get", "isSelected"],
            "#474747", // Halo negro para tienda seleccionada
            "#ffffff", // Halo blanco para tiendas no seleccionadas
          ],
          "text-halo-width": 2,
        },
      })

      // Añadir eventos de click para los círculos
      map.current.on("click", "circleOut", e => {
        if (e.features.length > 0) {
          const feature = e.features[0]
          const storeId = feature.properties.id
          const store = stores.find(s => s.pwid === storeId)

          if (store && onStoreSelect) {
            onStoreSelect(store)
          }
        }
      })

      map.current.on("click", "circleIn", e => {
        if (e.features.length > 0) {
          const feature = e.features[0]
          const storeId = feature.properties.id
          const store = stores.find(s => s.pwid === storeId)

          if (store && onStoreSelect) {
            onStoreSelect(store)
          }
        }
      })

      map.current.on("click", "storesIndex", e => {
        if (e.features.length > 0) {
          const feature = e.features[0]
          const storeId = feature.properties.id
          const store = stores.find(s => s.pwid === storeId)

          if (store && onStoreSelect) {
            onStoreSelect(store)
          }
        }
      })

      // Cambiar el cursor al pasar por encima de los círculos
      map.current.on("mouseenter", "circleOut", () => {
        map.current.getCanvas().style.cursor = "pointer"
      })

      map.current.on("mouseleave", "circleOut", () => {
        map.current.getCanvas().style.cursor = ""
      })

      map.current.on("mouseenter", "circleIn", () => {
        map.current.getCanvas().style.cursor = "pointer"
      })

      map.current.on("mouseleave", "circleIn", () => {
        map.current.getCanvas().style.cursor = ""
      })

      map.current.on("mouseenter", "storesIndex", () => {
        map.current.getCanvas().style.cursor = "pointer"
      })

      map.current.on("mouseleave", "storesIndex", () => {
        map.current.getCanvas().style.cursor = ""
      })

      // Añadir popup en hover
      // map.current.on('mouseenter', 'stores-circles', (e) => {
      //   if (e.features.length > 0) {
      //     const feature = e.features[0]
      //     const coordinates = e.features[0].geometry.coordinates.slice()
      //     const { nombre, direccion, localidad, provincia } = feature.properties

      //     // Ensure that if the map is zoomed out such that multiple
      //     // copies of the feature are visible, the popup appears
      //     // over the copy being pointed to.
      //     while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      //       coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
      //     }

      //     new maplibregl.Popup({
      //       closeButton: false,
      //       closeOnClick: false
      //     })
      //       .setLngLat(coordinates)
      //       .setHTML(`
      //         <div style="padding: 8px; min-width: 200px;">
      //           <h3 style="margin: 0 0 4px 0; font-weight: bold; font-size: 14px;">
      //             ${nombre}
      //           </h3>
      //           <p style="margin: 0 0 4px 0; font-size: 12px; color: #666;">
      //             ${direccion}
      //           </p>
      //           <p style="margin: 0; font-size: 11px; color: #888;">
      //             ${localidad}${provincia ? `, ${provincia}` : ''}
      //           </p>
      //         </div>
      //       `)
      //       .addTo(map.current)
      //   }
      // })

      // map.current.on('mouseleave', 'stores-circles', () => {
      //   map.current.getCanvas().style.cursor = ''
      //   // Cerrar cualquier popup abierto
      //   const popups = document.getElementsByClassName('maplibregl-popup')
      //   if (popups.length) {
      //     popups[0].remove()
      //   }
      // })
    })

    // Cleanup
    return () => {
      if (map.current) {
        map.current.remove()
        map.current = null
      }
    }
  }, [])

  // Actualizar datos cuando cambian las tiendas o la tienda seleccionada
  useEffect(() => {
    if (!mapLoaded || !map.current || !map.current.getSource("stores")) return
    // Actualizar los datos de la fuente
    const storesGeoJSON = storesToGeoJSON(stores, selectedStore)
    map.current.getSource("stores").setData(storesGeoJSON)

    // Ajustar vista del mapa para mostrar todas las tiendas
    if (storesGeoJSON.features.length > 0) {
      const bounds = new maplibregl.LngLatBounds()
      storesGeoJSON.features.forEach(feature => {
        bounds.extend(feature.geometry.coordinates)
      })

      map.current.fitBounds(bounds, {
        padding: 50,
        maxZoom: 13,
      })
    }
  }, [stores, selectedStore, mapLoaded])

  //Enfocar tienda seleccionada y cambiar el color del texto a blanco y circulo a negro
  useEffect(() => {
    if (!mapLoaded || !map.current || !selectedStore) return
    const store = transformStoreData(selectedStore)
    if (store.latitud && store.longitud) {
      map.current.flyTo({
        center: [store.longitud, store.latitud],
        zoom: 14,
        duration: 1000,
      })
    }
  }, [selectedStore, mapLoaded])

  return (
    <div css={tw`relative w-full h-full`} className={className}>
      <div ref={mapContainer} css={tw`w-full h-full`} />

      {/* Loading overlay */}
      {!mapLoaded && (
        <div
          css={tw`absolute inset-0 bg-gray-100 flex items-center justify-center`}
        >
          <div css={tw`text-center`}>
            <div
              css={tw`animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2`}
            ></div>
            <p css={tw`text-sm text-gray-600`}>Cargando...</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default StoreMap
